module.exports = __webpack_public_path__ + "img/horizontal_7_5_0.e8e361fa.png";